import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import useLocationHash from '../../src/hooks/useLocationHash';
const useLocationMock = () => {
  const $ = _c(6);
  const pathname = usePathname();
  const searchParamsObject = useSearchParams();
  let t0;
  if ($[0] !== searchParamsObject) {
    t0 = searchParamsObject.toString();
    $[0] = searchParamsObject;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const searchParamsString = `?${t0}`;
  const hash = useLocationHash();
  const t1 = pathname || "";
  let t2;
  if ($[2] !== hash || $[3] !== searchParamsString || $[4] !== t1) {
    t2 = {
      hash,
      pathname: t1,
      search: searchParamsString
    };
    $[2] = hash;
    $[3] = searchParamsString;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const location = t2;
  return location;
};
export default useLocationMock;